import axios from "axios";
import { useContext, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { useAlert } from "react-bootstrap-hooks-alert";
import eventContext from "../Contexts/EventContexts";
import { urlEvent } from "../endpoints";
import Button from "../Utils/Button";
import { EventDTO, MatchDTO } from "../Utils/Utils.models";
import { read, utils } from 'xlsx';
import FileSelect from "../Utils/FileSelect";
import EventSelector from "../Utils/EventSelector";
import LoadSchedule from "./LoadSchedule";
import NewEvent from "./NewEvent";


export default function EventSetup() {
    return (<>
        <div className="container w-75" >
            <h3 className="text-center align-middle">Event Setup</h3>
            <hr></hr>
            <NewEvent/>
            <hr></hr>
            <LoadSchedule/>

        </div>
    </>)
}